export default __webpack_public_path__ + "static/how-to-design-custom-crm-for-your-business-without-frustration-5883f959b2bdc570adfb1e173c501031.png";